"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useWriteSession = exports.useReadSession = exports.useSession = void 0;
var react_1 = require("react");
var neo4j_context_1 = require("./neo4j.context");
exports.useSession = function (defaultAccessMode, db) {
    var _a = react_1.useContext(neo4j_context_1.Neo4jContext), driver = _a.driver, database = _a.database;
    if (!driver)
        throw new Error('`driver` not defined in Neo4jContext. Have you added it into your app as <Neo4jProvider driver={{driver}}> ?');
    var databaseOrDefault = db || database;
    if (databaseOrDefault !== undefined && databaseOrDefault !== '') {
        return driver.session({ database: databaseOrDefault, defaultAccessMode: defaultAccessMode });
    }
    return driver.session({ defaultAccessMode: defaultAccessMode });
};
exports.useReadSession = function (db) { return exports.useSession("READ", db); };
exports.useWriteSession = function (db) { return exports.useSession("WRITE", db); };
